import { render, staticRenderFns } from "./ViewMedication.vue?vue&type=template&id=59b14b7c&scoped=true"
import script from "./ViewMedication.vue?vue&type=script&lang=js"
export * from "./ViewMedication.vue?vue&type=script&lang=js"
import style0 from "./ViewMedication.vue?vue&type=style&index=0&id=59b14b7c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59b14b7c",
  null
  
)

export default component.exports